import { FeaturedContentTypes as Type } from '../../../types/featuredcontent';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const AddFeaturedContentReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.ADD_FEATURED_CONTENT_REQUEST:
      return { ...state, loading: true, error: null, data: null };
    case Type.ADD_FEATURED_CONTENT_REQUEST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case Type.ADD_FEATURED_CONTENT_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false, data: null };
    case Type.RESET_ADD_FEATURED_CONTENT_REQUEST:
      return { ...initialState };
    default:
      return state;
  }
};

export default AddFeaturedContentReducer;
